import CbRadioGroup from './src/radio-group.vue';

CbRadioGroup.install = function(Vue) {
  Vue.component(CbRadioGroup.name, CbRadioGroup);
};

export default CbRadioGroup;
